import shoppingCartIcon from "../assets/svg/shopping-cart-icon.svg";
import windowCodeIcon from "../assets/svg/window-code-icon.svg";
import lockIcon from "../assets/svg/lock-icon.svg";
import { CyberSecurityListItem } from "../models/CybersecurityObject";
import { CyberSecurityFeature } from "../types/CyberSecurityTypes";
import { icons } from "../constants";

const iconsMap = {
  audit_consulting: icons.search,
  ethical_hacking: icons.hide,
  mssp: icons.show,
  vendors: icons.lightbulb,
  distributors: shoppingCartIcon,
  integrators: windowCodeIcon,

  courses: icons.cources,
  higher_education_institution: icons.education,
  b2b_training: icons.training,

  services_cb: lockIcon,
  association: icons.search,
  government_organization: icons.GovermentOrganization,
};

export const getCybersecurityIcon = (mapObject: CyberSecurityListItem) => {
  return lockIcon;
};

export const getCybersecurityIconForCategory = (category: string) => {
  if (category === "distributors") return iconsMap.distributors;
  if (category === "b2b_training") return iconsMap.b2b_training;
  if (category === "integrators") return iconsMap.integrators;
  if (category === "vendors") return iconsMap.vendors;
  if (category === "courses") return iconsMap.courses;
  if (category === "higher_education_institution")
    return iconsMap.higher_education_institution;
  if (category === "audit_consulting") return iconsMap.audit_consulting;
  if (category === "ethical_hacking") return iconsMap.ethical_hacking;
  if (category === "mssp") return iconsMap.mssp;
  if (category === "association") return iconsMap.association;
  if (category === "government_organization")
    return iconsMap.government_organization;

  return lockIcon;
};

export const getCybersecurityIconForPoint = (
  mapObject: CyberSecurityFeature
) => {
  return lockIcon;
};

export function getDomainFromAddress(address: string): string | undefined {
  if (!address) return undefined;

  try {
    const url = address.startsWith("http")
      ? new URL(address)
      : new URL(`https://${address}`);
    return url.hostname.replace(/^www\./, "");
  } catch {
    return undefined;
  }
}
